enum Relationship {
    Code = "RELATIONSHIP",

    Father = "Father",
    Mother = "Mother",
    Daughter = "Daughter",
    Son = "Son",
    Brother = "Brother",
    Sister = "Sister",
    PaternalGrandFather = "PaternalGrandFather",
    PaternalGrandMother = "PaternalGrandMother",
    PaternalSibling = "PaternalSibling",
    MaternalGrandFather = "MaternalGrandFather",
    MaternalGrandMother = "MaternalGrandMother",
    Other = "Other",
    MaternalSibling = "MaternalSibling",
    Attendant = "Attendant",
    Cousin = "Cousin",
    Guardian = "Guardian",
    Proxy = "Proxy",
    Tutor = "Tutor"
}

enum Weight {
    Code = "WEIGHTTYPE",

    Kilogram = "KILOGRAM",
    Pound = "POUND"
}

enum Height {
    Code = "HEIGHTTYPE",

    Centimeter = "CENTIMETER",
    Inch = "INCH"
}

enum TemperatureUnitsLookup {
    Code = "TemperatureUnits",

    Celcius = "CelciusUnit",
    FahrenheitUnit = "FahrenheitUnit"
}

enum TemperatureLocationsLookup {
    Code = "TemperatureLocations",

    Rectal = "TLRectal",
    Unspecified = "TLUnspecified",
    Axillary = "TLAxillary",
    Oral = "TLOral",
    Ear = "TLEar"
}

enum CanadaState {
    Code = "CanadaState",

    Alberta = "CanadaState_AB",
    BritishColumbia = "CanadaState_BC",
    Manitoba = "CanadaState_MB",
    NewBrunswick = "CanadaState_NB",
    Newfoundland = "CanadaState_NL",
    NovaScotia = "CanadaState_NS",
    Ontario = "CanadaState_ON",
    PrinceEdwardIsland = "CanadaState_PE",
    Quebec = "CanadaState_QC",
    Saskatchewan = "CanadaState_SK",
    NorthwestTerritories = "CanadaState_NT",
    Yukon = "CanadaState_YT",
    Nunavut = "CanadaState_NU"
}

enum CountryNames {
    Code = "COUNTRYNAMES",

    Canada = "CNCANADA",
    Usa = "CNUSA",
    Mexico = "CNMEXICO",
    Colombia = "CNCOLOMBIA",
    Other = "CNOTHER"
}

enum RelationshipLinks {
    Code = "RELATIONLINKS",

    Father = "RLFather",
    Mother = "RLMother",
    Spouse = "RLSpouse",
    Sibling = "RLSibling",
    Grandparent = "RLGrandparent",
    Child = "RLChild",
    Grandchild = "RLGrandchild",
    Other = "RLOther",
    Duplicate = "RLDuplicate"
}

enum GenderLookup {
    Code = "Gender",

    Male = "MALE",
    Female = "FEMALE",
    Other = "OTHERGENDER"
}

enum CreatinineClearanceAlgorithmLookup {
    Code = "CREACLEARALGO",

    CockcroftGault = "CG",
    MDRD = "MDRD",
    MDRD175 = "MDRD175",
    CKDEPI = "CKDEPI",
    CKD_EPI = "CKD-EPI"
}

enum BloodGlucoseUnitsLookup {
    Code = "BloodGlucoseUnits",

    millimolesPerLitres = "BGUmmolL",
    milligramsPerDecilitres = "BGUmgdL"
}

enum ContactPointTypeLookup {
    Code = "CONTACTPOINTTYPE",

    Personal = "PERSONAL",
    Work = "WORK",
    Other = "OTHERCONTACTPOINT"
}

enum PhoneTypeLookup {
    Code = "PHONETYPE",

    Fax = "FAX",
    Phone = "PHONE",
    Pager = "PAGER",
    Mobile = "MOBILE"
}

// Not in the flat look ups.
enum SerumCreatinineUnitHardCoded {
    MicromolesPerLitre = "μmol/L",
    MilligramPer100Millilitres = "mg/100ml"
}

enum TaskStatusLookup {
    Code = "TaskStatus",
    Completed = "Completed"
}

enum MedicalRequestStatusLookupCodes {
    Code = "MedicalRequestStatus",
    PENDING = "PENDING",
    INVESTIGATION = "INVESTIGATION",
    RESULTSRECEIVED = "RESULTSRECEIVED",
    SENT = "SENT",
    RECEIVEDBY3rdPARTY = "RECEIVEDBY3rdPARTY",
    REJECTEDBY3rdPARTY = "REJECTEDBY3rdPARTY",
    WAITLIST = "WAITLIST",
    PATIENTCONTACTTEDBY3rdPARTY = "PATIENTCONTACTTEDBY3rdPARTY",
    APPOINTMENTSCHEDULED = "APPOINTMENTSCHEDULED",
    REPORTRECEIVED = "REPORTRECEIVED",
    CANCELLED = "CANCELLED",
    CLOSED = "CLOSED",
    DRAFT = "DRAFT"
}

enum DiscontinueReason {
    Code = "DiscontinueReason",
    Other = "OTHER"
}

enum ExternalBillingPaymentMode {
    Code = "ExternalBillingPaymentMode",
    RegularPaymentMode = "RegularPaymentMode",
    AlternativePaymentMode = "AlternativePaymentMode"
}

export {
    BloodGlucoseUnitsLookup,
    CanadaState,
    ContactPointTypeLookup,
    CountryNames,
    CreatinineClearanceAlgorithmLookup,
    DiscontinueReason,
    ExternalBillingPaymentMode,
    GenderLookup,
    Height,
    MedicalRequestStatusLookupCodes,
    PhoneTypeLookup,
    Relationship,
    RelationshipLinks,
    SerumCreatinineUnitHardCoded,
    SerumCreatinineUnitHardCoded as SerumCreatinineUnitLookup,
    TaskStatusLookup as TaskStatus,
    TemperatureLocationsLookup,
    TemperatureUnitsLookup,
    Weight
};
